module.exports = " <div class=\"textarea-input clearfix form-group\" v-bind:class=\"{ 'has-feedback' : field.dirty }\"> <label v-bind:for=field.name class=\"col-sm-4 control-label\">{{ field.label }}</label> <div class=col-sm-8> <textarea v-bind:id=field.name class=form-control type=text v-model=field.value v-bind:name=field.name v-bind:style=\"{minHeight: field.height || '350px'}\"></textarea> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/inputs/TextareaInput.vue
// module id = 746
// module chunks = 2